<div class="sidebar-container">
    <div class="sidebar">
        <div class="sidebar-content">
            <!-- New Contract Check button -->
            <button mat-raised-button color="primary" (click)="openNewContractDialog()">
                <mat-icon>add</mat-icon>
                New Prompt Set
            </button>

            <button mat-stroked-button color="primary" (click)="openImportDialog()" style="margin-top:8px">
                <mat-icon>file_download</mat-icon>
                Import Prompt Sets &amp; Prompts
            </button>

            <button mat-stroked-button color="accent" (click)="exportToExcel()" style="margin-top:8px">
                <mat-icon>file_upload</mat-icon>
                Export Prompt Sets &amp; Prompts
            </button>

            <!-- Contract checks list -->
            <mat-list>
                @for (check of contractChecks; track check.prompt_set_id) {
                <mat-list-item [class.selected]="selectedCheck?.prompt_set_id === check.prompt_set_id" (click)="onSelectCheck(check)">
                    <span matListItemTitle [title]="check.name" class="sidebar-title-row">
                        <!-- Access level icon -->
                        @if (check.published && check.access_level) {
                        <mat-icon class="sidebar-access-icon"
                            [class.icon-subscription]="check.access_level === 'subscription_level'"
                            [class.icon-public]="check.access_level === 'public'"
                            [matTooltip]="check.access_level === 'subscription_level' ? 'Published · Subscription only' : 'Published · Everyone'"
                            matTooltipPosition="right">
                            {{ check.access_level === 'subscription_level' ? 'lock' : 'public' }}
                        </mat-icon>
                        } @else if (!check.published) {
                        <mat-icon class="sidebar-access-icon icon-unpublished"
                            matTooltip="Not yet published"
                            matTooltipPosition="right">
                            visibility_off
                        </mat-icon>
                        }
                        <span class="sidebar-name">{{ check.name }}</span>
                        <!-- Draft dot: published before but updated since -->
                        @if (check.status === 'draft' && check.published_at) {
                        <span class="draft-dot"
                            matTooltip="Updated since last publish"
                            matTooltipPosition="right"></span>
                        }
                    </span>
                    <button mat-icon-button [matMenuTriggerFor]="menu" matListItemMeta (click)="$event.stopPropagation()">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item (click)="onEdit(check)" class="action-button">
                            <mat-icon>edit</mat-icon>
                            <span>Edit</span>
                        </button>
                        <button mat-menu-item (click)="importIntoPromptSet(check)" class="action-button">
                            <mat-icon>file_download</mat-icon>
                            <span>Import Prompts</span>
                        </button>
                        <button mat-menu-item (click)="exportSelectedToExcel()" class="action-button">
                            <mat-icon>file_upload</mat-icon>
                            <span>Export Prompts</span>
                        </button>
                        <button mat-menu-item 
                            (click)="onDelete(check)" 
                            class="action-button"
                            [disabled]="check.published"
                            [matTooltip]="check.published ? 'Published prompt sets cannot be deleted. If you wish to delete, please contact the administrator.' : ''"
                            matTooltipPosition="left">
                            <mat-icon>delete</mat-icon>
                            <span>Delete</span>
                        </button>
                    </mat-menu>
                </mat-list-item>
                }
            </mat-list>
        </div>
    </div>
</div>